import { Title } from "@solidjs/meta";
import { ButtonLink } from "~/common/button";
import { createPatientText, type PatientI18n, PatientTextProvider } from "~/patient_i18n/i18n";
import { PatientLanguageBar } from "~/patient_i18n/language_bar";
import { optInPaths, type OptInOwner } from "~/sms_opt_in/paths";
import { PublicConfirmation, PublicLocationCard } from "../_location_card";

type Props = {
  owner: OptInOwner;
  locationName: string;
  logoUrl: string | null;
  addressLines: string[] | null;
  phone: string | null;
  patientI18n: PatientI18n;
};

export default function SmsOptInOptOut(props: Props) {
  // The language only changes on a full page load, so the strings are read once.
  // eslint-disable-next-line solid/reactivity
  const text = createPatientText(props.patientI18n);
  const t = text.t;
  const stopPrevious = () =>
    props.phone
      ? t("sms_opt_in.stop_previous_with_phone", { name: props.locationName, phone: props.phone })
      : t("sms_opt_in.stop_previous", { name: props.locationName });

  return (
    <PatientTextProvider value={text}>
      <Title>{t("sms_opt_in.opt_out_page_title", { name: props.locationName })}</Title>

      <PublicLocationCard
        locationName={props.locationName}
        logoUrl={props.logoUrl}
        addressLines={props.addressLines}
        phone={props.phone}
        toolbar={<PatientLanguageBar />}
      >
        <PublicConfirmation title={t("sms_opt_in.opt_out_title")}>
          {t("sms_opt_in.opt_out_body", { name: props.locationName })}
        </PublicConfirmation>

        <div class="mt-4 rounded-xl border border-brand-subtle bg-brand-light px-4 py-4 text-sm text-typography-secondary">
          <p class="font-medium text-typography-primary">{t("sms_opt_in.already_receiving")}</p>
          <p class="mt-2">{stopPrevious()}</p>
        </div>

        <div class="mt-6 flex justify-center">
          <ButtonLink href={optInPaths(props.owner).optIn} variant="secondary">
            {t("sms_opt_in.change_mind")}
          </ButtonLink>
        </div>
      </PublicLocationCard>
    </PatientTextProvider>
  );
}
